import { initial_state_users } from "../apps/users/constant";
import { initial_state_roles } from "../apps/roles/constants";
import { initial_state_retailer_report } from "../apps/retailer/RetailerReportsConstants";

const initialState = {
  tabs: [
    initial_state_users,
    initial_state_roles,
    initial_state_retailer_report,
  ],
  activeTabIndex: 0,
  configData: {},
};

const commonReducer = (state = initialState, action) => {
  if (action.type === "update_active_tab_index") {
    state.activeTabIndex = action.payload;
    return { ...state };
  }
  if (action.type === "update_tabs") {
    state.tabs = action.payload;
    return { ...state };
  }
  if (action.type === "add_report_data_to_redux") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      data: action.payload,
    };
    return { ...state };
  }
  if (action.type === "update_current_focus") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      currentFocus: action.payload,
    };
    return {
      ...state,
    };
  }
  if (action.type === "refresh_tabs") {
    return initialState;
  }
  if (action.type === "set_config_data") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      configData: action.payload,
    };
    return { ...state };
  }
  if (action.type === "active_config_tab") {
    state.tabs[state.activeTabIndex].activeConfigTab = {
      ...action.payload,
    };
    return { ...state };
  }
  if (action.type === "update_config_data") {
    state.tabs[state.activeTabIndex] = {
      ...state.tabs[state.activeTabIndex],
      configData: {
        ...state.tabs[state.activeTabIndex].configData,
        ...action.payload,
      },
    };
    return { ...state };
  }
  return state;
};

export default commonReducer;
